import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { brandsActions } from './brand-actions';
import { delay, exhaustMap } from 'rxjs';
import { PrinterService } from '../../../api/services';
import { mapResponse } from '@ngrx/operators';
import { LoadingState } from '../models/loader.model';
import { getErrorMessage, ZetraError } from '../../shared/errors/error-messages.helper';

export const brandsEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(brandsActions.loadBrands),
      exhaustMap((props) =>
        compService.printerControllerFindAllPrinterBrand({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => brandsActions.loadDoneBrands({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: { message: string }) =>
              brandsActions.loadDoneBrands({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco dei brands." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const singleBrandEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(PrinterService)) => {
    return actions$.pipe(
      ofType(brandsActions.single),
      exhaustMap((props) =>
        compService.printerControllerFindOnePrinterBrand({ ...props }).pipe(
          delay(1000),
          mapResponse({
            next: (r) => brandsActions.singleDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: (error: ZetraError) =>
              brandsActions.singleDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: getErrorMessage(error.errorCode) },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
